define('plugins/musicfavourite/nls/track/dialog',{
    'en-gb': {
        'upsell': {
            'heading': 'Add this track for later',
            'text': 'You&#39;ll get better music recommendations based on what you add. And you can listen in full on Deezer, Spotify or YouTube.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this track'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'cy-gb': { //WELSH
        'upsell': {
            'heading': 'Add this track for later',
            'text': 'You&#39;ll get better music recommendations based on what you add. And you can listen in full on Deezer, Spotify or YouTube.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this track'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'ga-gb': { //IRISH
        'upsell': {
            'heading': 'Add this track for later',
            'text': 'You&#39;ll get better music recommendations based on what you add. And you can listen in full on Deezer, Spotify or YouTube.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this track'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    },
    'gd-gb': { //SCOTTISH
        'upsell': {
            'heading': 'Add this track for later',
            'text': 'You&#39;ll get better music recommendations based on what you add. And you can listen in full on Deezer, Spotify or YouTube.',
            'signIn': 'Sign in',
            'signInText1': ' ',
            'signInText2': 'or',
            'signInText3': 'Register',
            'signInText4': 'to add this track'
        },
        'limited': {
            'heading': 'Sorry, you’ve reached the limit'
        }
    }
});

